import { observable, action } from "mobx";
import { axios } from "../../utils/axios";
import { QuizUserSubjectTracking } from "./subjects/quiz-user-subject-tracking";

export default class QuestionListStore {
        @observable questions = []; // 'pending' / 'done' / 'error'
        @observable subjectTracking: QuizUserSubjectTracking | undefined = undefined;
        @observable rootStore: any = undefined; // 'pending' / 'done' / 'error'
        @observable status: string | undefined = undefined;

        assignQuestions(res: any) {
            this.questions = res.quizUserTracking;
            this.subjectTracking = new QuizUserSubjectTracking(res.quizUserSubjectTracking);
        }
        
        fetch(subject_user: string, subject_slug: string) {
            var store = this;
            this.status = "pending";
    
            axios()
                .get(`/subjects/${subject_user}/${subject_slug}/questions`)
                .then((res: any) => res.data)
                .then((res: any) => this.assignQuestions(res))
                .then(() => { store.status = "done"; })
                .catch((err: any) => {
                    store.status = "error";
                });
        }
    
    
    constructor(rootStore: any) {
        this.rootStore = rootStore;
    }

}
